import { events, messageBus } from "@schibsted-nmp/advertising-events";
import WarpElement from "@warp-ds/elements-core";
import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { PodletMetaData } from "../../../types/types-drEdition.js";
import { getPodletMetaData, setupCustomElement } from "../../lit-util.js";

const NAME = "contentful-sov-fetcher";

class ContentfulSovFetcher extends WarpElement {
	metaData!: PodletMetaData;
	ssrHtml!: string | null;

	static properties = {
		adPosition: { type: String },
	};

	constructor() {
		console.log("ContentfulSovFetcher constructor");
		super();

		this.metaData = getPodletMetaData();
	}

	firstUpdated() {
		console.log("ContentfulSovFetcher firstUpdated() with metaData:", this.metaData);
		if (this.metaData) {
			this.fetchContentMarketingData().then((contentMarketingRes) => {
				this.ssrHtml = contentMarketingRes;
				messageBus.publish(events.PODLET.channel, "render-sponsored-content", Boolean(contentMarketingRes));
				this.requestUpdate();
			});
		}
	}

	async fetchContentMarketingData(): Promise<string | null> {
		const { baseUrl, vertical } = this.metaData;
		const fetchUrl = `${baseUrl}/api/advertising/contentful/html/teaser/sov?vertical=${vertical}`;
		console.log("Fetching SOV content from:", fetchUrl);
		try {
			const res = await fetch(fetchUrl).then((res) => {
				if (res.status === 200) {
					return res.json();
				} else {
					return null;
				}
			});
			return res?.html;
		} catch (e) {
			console.log(e);
			return null;
		}
	}

	render() {
		console.log("ContentfulSovFetcher render()");
		return html`${this.ssrHtml ? unsafeHTML(this.ssrHtml) : ""}`;
	}
}

setupCustomElement(NAME, ContentfulSovFetcher);
